<pr-form
  (onSubmit)="submit()"
  title="Paramétrez votre simulation"
  [formGroup]="form"
>
  @if (submitErrorMessages.length) {
    <pr-color-panel display="danger" clazz="mbm">
      <pr-panel-body clazz="pam">
        <div role="alert">
          <ul class="submit-errors">
            @for (message of submitErrorMessages; track message) {
              <li>{{ message }}</li>
            }
          </ul>
        </div>
      </pr-panel-body>
    </pr-color-panel>
  }

  @if (isConsultant) {
    <pr-input label="Crédit" [derrors]="derrors">
      <mat-select
        formControlName="productId"
        (selectionChange)="
          calculateInterestRate(
            form.get('productId').value,
            form.get('durationTotalInMonth').value,
            form.get('amountBorrowed').value,
            form.get('amountMonthly').value
          )
        "
      >
        <mat-option [value]="null"> </mat-option>
        @for (product of products; track product) {
          <mat-option [value]="product.id">
            {{ product.name }}
          </mat-option>
        }
      </mat-select>
    </pr-input>
  }

  <!-- MODE SIMPLE - MODE AVANCE -->
  <pr-input-radio-round
    formControlName="mode"
    label="Mode"
    [options]="[
      { value: true, label: 'Mode simple' },
      { value: false, label: 'Mode avancé' },
    ]"
  >
  </pr-input-radio-round>

  <h3>Informations du crédit</h3>

  <pr-input-radio
    [hidden]="form.get('mode').value"
    formControlName="type"
    label="Type de crédit"
    [options]="[
      { value: 'FIX', label: 'Fixe' },
      { value: 'IN_FINE', label: 'In Fine' },
    ]"
  >
  </pr-input-radio>

  <pr-input-radio
    [hidden]="hasPaliers"
    formControlName="simuChoice"
    label="Choix de la simulation"
    [options]="[
      { value: true, label: 'Montant' },
      { value: false, label: 'Mensualité' },
    ]"
  >
  </pr-input-radio>

  <pr-input
    [hidden]="!form.get('simuChoice').value"
    [label]="'Capital emprunté'"
    [suffix]="'€'"
    [derrors]="derrors"
  >
    <input
      formControlName="amountBorrowed"
      type="text"
      (change)="
        calculateInterestRate(
          form.get('productId').value,
          form.get('durationTotalInMonth').value,
          form.get('amountBorrowed').value,
          form.get('amountMonthly').value
        )
      "
    />
  </pr-input>

  <pr-input
    [hidden]="form.get('simuChoice').value || hasPaliers"
    [label]="'Mensualité'"
    [suffix]="'€'"
    [derrors]="derrors"
  >
    <input
      formControlName="amountMonthly"
      type="text"
      (change)="
        calculateInterestRate(
          form.get('productId').value,
          form.get('durationTotalInMonth').value,
          form.get('amountBorrowed').value,
          form.get('amountMonthly').value
        )
      "
    />
  </pr-input>

  <pr-input label="Durée" suffix="mois" [derrors]="derrors">
    <input
      formControlName="durationTotalInMonth"
      type="number"
      (change)="
        calculateInterestRate(
          form.get('productId').value,
          form.get('durationTotalInMonth').value,
          form.get('amountBorrowed').value,
          form.get('amountMonthly').value
        )
      "
      max="420"
    />
  </pr-input>

  <pr-input
    [label]="
      form.get('mode').value ? 'Frais de dossier' : 'Frais de dossier/Courtage'
    "
    suffix="€"
    [derrors]="derrors"
  >
    <input formControlName="amountFee" type="text" />
  </pr-input>

  <pr-input label="Taux d'intérêt" suffix="%" [derrors]="derrors">
    <input formControlName="interestRate" type="text" />
  </pr-input>

  <div [hidden]="form.get('mode').value">
    <h3>Informations de l'assurance</h3>
  </div>

  <pr-input-radio
    [hidden]="form.get('mode').value || form.get('type').value === 'IN_FINE'"
    formControlName="insuranceType"
    label="Mode de calcul"
    [options]="[
      { value: 'AMOUNT_BORROWED', label: 'Capital emprunté' },
      { value: 'LOAN_LEFT', label: 'Montant restant dû' },
    ]"
  >
  </pr-input-radio>

  <pr-input label="Taux d'assurance" suffix="%" [derrors]="derrors">
    <input formControlName="insuranceRate" type="text" />
  </pr-input>

  <pr-input
    [hidden]="form.get('mode').value"
    label="Quotité d'assurance"
    suffix="%"
    [derrors]="derrors"
  >
    <input formControlName="insuranceQuotite" type="text" />
  </pr-input>

  <div [hidden]="!isPaliersAvailable">
    <h3>Paliers</h3>

    <ea-loan-paliers
      [form]="form"
      [derrors]="derrors"
      [startDate]="simulationStartDate"
    ></ea-loan-paliers>
  </div>

  <div [hidden]="form.get('mode').value || hasPaliers">
    <h3>Informations sur le différé</h3>
  </div>

  <pr-input-radio
    [hidden]="form.get('mode').value || hasPaliers"
    formControlName="differe"
    label="Type de différé"
    [options]="[
      { value: 'TOTAL', label: 'Total' },
      { value: 'PARTIEL', label: 'Partiel' },
    ]"
  >
  </pr-input-radio>

  <pr-input
    [hidden]="form.get('mode').value || hasPaliers"
    label="Durée du différé"
    suffix="mois"
    [derrors]="derrors"
  >
    <input formControlName="durationDiffereInMonth" type="text" />
  </pr-input>

  <div class="alert alert-success space" role="alert">
    <div>TAEG (Taux annuel effectif global)</div>
    @if (entity.taeg != null) {
      <div style="font-weight: bold">
        {{ entity.taeg * 100 | number: '1.0-2' }} %
      </div>
    }
  </div>
</pr-form>
